export default [
    {
        path: '/website/country',
        props: true,
        component: () => import('@/views/Country/Website'),
    },
    {
        path: '/website/country/:id',
        props: true,
        component: () => import('@/views/Country/Website/Show'),
    },
];
